export const AB_TEST_METRIC_DISPLAY_MODE_IP = 'ip';
export const AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION = 'attribution';
export const AB_TEST_SWITCH_SCENE = 1;

const getFormCollectFields = (formDetail: any) => {
  const settings = formDetail?.settings || {};
  const startFields = Array.isArray(settings?.start) ? settings.start : [];
  const middleFields = Array.isArray(settings?.middle) ? settings.middle : [];
  return [...startFields, ...middleFields];
};

export const hasAbtestCollectFields = (formDetail: any) => {
  return getFormCollectFields(formDetail).length > 0;
};

export const hasAbtestSmsSubscription = (formDetail: any) => {
  const rules = formDetail?.settings?.rules || {};
  return rules?.buttonAction === 'sms' || rules?.middleButtonAction === 'sms';
};

export const resolveAbtestMetricDisplayMode = (sceneType: number, formDetails: any[] = []) => {
  if (sceneType === AB_TEST_SWITCH_SCENE) {
    return AB_TEST_METRIC_DISPLAY_MODE_IP;
  }

  const shouldUseIpMetrics = formDetails.some((formDetail) => {
    return !hasAbtestCollectFields(formDetail) || hasAbtestSmsSubscription(formDetail);
  });

  return shouldUseIpMetrics
    ? AB_TEST_METRIC_DISPLAY_MODE_IP
    : AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION;
};

export const shouldUseAbtestAttributionMetrics = (
  metricDisplayMode?: string | null,
  fallback = false
) => {
  if (metricDisplayMode === AB_TEST_METRIC_DISPLAY_MODE_ATTRIBUTION) {
    return true;
  }
  if (metricDisplayMode === AB_TEST_METRIC_DISPLAY_MODE_IP) {
    return false;
  }
  return fallback;
};
